import moment from 'moment'

export default class DateUtils {

  static getDateDifferenceNamePast(time, curTime = new Date()) {
    let logTime = moment(time).local().startOf('day')
    let curTimeMoment = moment(curTime).local().startOf('day')

    let diffDays = curTimeMoment.diff(logTime, 'days')
    let diffMonths = curTimeMoment.diff(logTime, 'months')

    if(logTime.isSame(curTimeMoment, 'days'))
      return 'Today'
    if(diffDays <= 1)
      return 'Yesterday'
    if(diffDays <= 7)
      return 'Last Week'

    if(diffMonths <= 6)
      return logTime.format('MMMM')
    if(diffMonths <= 18)
      return logTime.format('MMMM YYYY')
      
    return logTime.format('YYYY')
  }

  static getDateDifferenceNameFuture(time, curTime = new Date()) {
    let logTime = moment(time).local().startOf('day')
    let curTimeMoment = moment(curTime).local().startOf('day')

    let diffDays = logTime.diff(curTimeMoment, 'days')

    if(logTime.isSame(curTimeMoment, 'days'))
      return 'Today'

    if(diffDays < 0)
      return DateUtils.getDateDifferenceNamePast(time, curTime)

    if(diffDays <= 1)
      return 'Tomorrow'
    if(diffDays <= 7)
      return logTime.format('dddd Do')
    if(diffDays <= 30)
      return logTime.format('Do MMM')

    return logTime.format('Do MMM YYYY')
  }

  static areDatesSameDay(date1, date2) {
    let day1 = moment(date1).local().startOf('day')
    let day2 = moment(date2).local().startOf('day')

    return day1.isSame(day2, 'days')
  }

  static isDateToday(date) {
    return DateUtils.areDatesSameDay(date, new Date())
  }

  static getTimeOfDaySalutationText() {
    var currentHour = moment().local().format("HH");

    if (currentHour >= 3 && currentHour < 12){
      return "Good Morning";
    } else if (currentHour >= 12 && currentHour < 16){
      return "Good Afternoon";
    }   else if (currentHour >= 16 && currentHour < 20){
      return "Good Evening";
    } else if (currentHour >= 20 || currentHour < 3){
      return "Good Night";
    } else {
      return "Hello"
    }
  }
}
